import service from '@/utils/request'
// 查询货币种类
export function basicCurrencyList(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/basicCurrencyList',
        data: param
    })
}
export function basicCurrencyListAll() {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/list',
    })
}
export function addBasicCurrency(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/add',
        data: param
    })
}
export function editBasicCurrency(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/edit',
        data: param
    })
}

export function batchDelBasicCurrency(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/batchDel',
        data: param
    })
}

export function delBasicCurrency(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/del',
        data: param
    })
}
